import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TagStatesDaoService } from './dao/tag-states-dao.service';
import { TagStatesStorageDaoService } from './dao/tag-states-dao/tag-states-storage-dao.service';
import { TagStatesService } from './logic/tag-states.service';
import { TagStatesLogicService } from './logic/tag-states/tag-states-logic.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [
        { provide: TagStatesService, useClass: TagStatesLogicService },
        { provide: TagStatesDaoService, useClass: TagStatesStorageDaoService }
    ]
})
export class TagStatesModule { }